"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ClickOutside =
/** @class */
function (_super) {
  __extends(ClickOutside, _super);

  function ClickOutside() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.isTouch = false;
    _this.containerRef = react_1.default.createRef();

    _this.handle = function (e) {
      var _a = _this.props,
          onClickOutside = _a.onClickOutside,
          disabled = _a.disabled; // Temporary disable handler

      if (disabled === true) {
        return;
      }

      if (e.type === 'touched') {
        _this.isTouch = true;
      }

      if (e.type === 'click' && _this.isTouch) {
        return;
      }

      var el = _this.containerRef.current;

      if (el && !el.contains(e.target)) {
        // tslint:disable-next-line:no-string-literal
        e['outside'] = _this.props.id;
        onClickOutside();
      }
    };

    return _this;
  }

  ClickOutside.prototype.componentDidMount = function () {
    document.addEventListener('touchend', this.handle, true);
    document.addEventListener('click', this.handle, true);
  };

  ClickOutside.prototype.componentWillUnmount = function () {
    document.removeEventListener('touchend', this.handle, true);
    document.removeEventListener('click', this.handle, true);
  };

  ClickOutside.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        onClickOutside = _a.onClickOutside,
        props = __rest(_a, ["children", "onClickOutside"]);

    return react_1.default.createElement("div", __assign({
      ref: this.containerRef
    }, props), children);
  };

  return ClickOutside;
}(react_1.Component);

exports.default = ClickOutside;